<template lang="pug">
  .component-backoffice-create-zone
    .row
      .column.small-12.large-6
        label Select zone
          select(v-model="body.zone_id")
            option(:value="null") Select zone
            option(v-for="(zone, id) in zones", :value="zone.id" ) {{zone.name}}
      .column
        label Type
          input(type="text", v-model="body.type")
      .column
        label Color
          input(type="text", v-model="body.color")

    .row
      .column
        label On reservation start
        SelectizeCommonCost(@optionSelected="setCommonCost('start_common_cost_id', $event)", @optionRemoved="unsetCommonCost('start_common_cost_id')", :selectedValue="body.start_common_cost_id")
        label Show on public map
        input(type="checkbox", v-model="body.show")
      .column
        label On reservation end
        SelectizeCommonCost(@optionSelected="setCommonCost('end_common_cost_id', $event)", @optionRemoved="unsetCommonCost('end_common_cost_id')", :selectedValue="body.end_common_cost_id")
        label Max vehicles
          input(v-model="body.max_vehicles", type="number", min="0")
        label Min fuel level
          input(v-model="body.min_fuel_level", type="number", min="0")
        label Max speed
          input(v-model="body.max_speed", type="number", min="0")
    .row
      .column
        ActionButton(:action="save") Save
    .row.column
      GoogleMapContainer
        GoogleMap(
          style="height:500px", ref="map", :api-key="apiKey",
          :center="mapCenter",  :libraries="['places','visualization','drawing']", :zoomControl="true", :mapTypeControl="true")
          google-map-polygon(v-if="body.zone_id !== null", v-for="p in selectedPoly", :positions="p", :color="body.color", :fillColor="body.color")

</template>

<script>
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import GoogleMap from '../../lib/map/GoogleMap.vue'
  import {mapState} from 'vuex'
  import GoogleMapContainer from '../../components/backoffice/GoogleMapContainer'
  import SelectizeCommonCost from '../../components/structure/ui/lists/selectize/SelectizeCommonCost'
  import GoogleMapPolygon from '../../lib/map/GoogleMapPolygon'
  import ActionButton from '../../components/structure/ui/ActionButton'
  import MaggieHelper from '../../maggieHelper'

  export default {
    name: 'ZoneConfigForm',
    components: {ActionButton, SelectizeCommonCost, GoogleMapContainer, GoogleMap, GoogleMapPolygon},
    data() {
      return {
        apiKey: null,
        zones: [],
        options: [],
        body: {
          zone_id: null,
          show: true,
          start_common_cost_id: null,
          end_common_cost_id: null,
          max_vehicles: 0,
          min_fuel_level: 0,
          max_speed: null,
          color: null,
          type: null
        },

      }
    },
    created() {
      this.apiKey = window.env.GOOGLE_MAPS_KEY
      KeplerBackofficeSdk.zones.list.all((data) => {
        this.zones = data
      })
      if (this.item !== null) {
        Object.assign(this.body, this.item)
        this.body.zone_id = this.item.zone.id
        this.body.start_common_cost_id = this.item.common_cost_start !== null ? this.item.common_cost_start.id : null
        this.body.end_common_cost_id = this.item.common_cost_end !== null ? this.item.common_cost_end.id : null
      }
    },
    methods: {
      setCommonCost(type, obj) {
        this.body[type] = obj.id
      },
      unsetCommonCost(type) {
        this.body[type] = null
      },
      save() {
        if (this.item !== null) {
          return KeplerBackofficeSdk.zoneConfigurations.select(this.item).edit(this.body, () => {
            MaggieHelper.notification('Zone configuration', 'Configuration edited')
            this.$router.push({name: 'zone-configuration'})

          })
        }

        return KeplerBackofficeSdk.zoneConfigurations.make(this.body, () => {
          MaggieHelper.notification('Zone configuration', 'Configuration created')

          this.$router.push({name: 'zone-configuration'})
        })
      },
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
      mapCenter() {
        return {
          lat: this.configuration.application.application_default_latitude.value,
          lng: this.configuration.application.application_default_longitude.value,
        }
      },
      selectedZone() {
        return this.zones.findIndex((item) => item.id === this.body.zone_id)
      },
      selectedPoly() {
        return this.selectedZone !== -1 ? this.zones[this.selectedZone].poly : []
      }
    },
    props: {
      item: {
        default: null
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// ZoneConfigForm.vue?68056388